import React from "react";
import Project from "../Components/Project";
import { projectDetails } from "../Details";

function Projects() {
  return (
    <div className="w-full min-h-screen">
      <main className="max-width pt-16 md:pt-20 pb-20">
        <h1 className="text-gradient text-2xl md:text-4xl xl:text-5xl xl:leading-tight font-bold mb-10">
          Recent Features
        </h1>
        <div className="flex flex-col gap-10">
          {projectDetails.map(({ title, image, description, features, previewLink, githubLink }, index) => (
            <Project
              key={title}
              index={index}
              title={title}
              image={image}
              description={description}
              features={features}
              previewLink={previewLink}
              githubLink={githubLink}
            />
          ))}
        </div>
      </main>
    </div>
  );
}

export default Projects;
